module.exports = __webpack_public_path__ + "static/media/ReportConsumo.9ff2bc8a.svg";